import Weezevent from './weezevent'; 

export default class WeezeventDesktop extends Weezevent {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/weezevent/weezevent.desktop.js